namespace GeniuzPOS.Inventory {
    export class IcStockApproveSetAssembleDtColumns {
        static columnsKey = 'Inventory.IcStockApproveSetAssembleDt';
    }
}
